import { render, staticRenderFns } from "./WorkOrderTaskDataInfo.vue?vue&type=template&id=970ab55e&scoped=true"
import script from "./WorkOrderTaskDataInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkOrderTaskDataInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WorkOrderTaskDataInfo.vue?vue&type=style&index=0&id=970ab55e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970ab55e",
  null
  
)

export default component.exports